<template>
  <section class="l-section wpb_row height_small mpc-row mpc-row images-carousel"
           :class="selector"
  >
    <div class="l-section-h  images-carousel__inner">
      <h4 class="images-carousel__title">{{carousel.name}}</h4>
      <div class="images-carousel__carousel">
        <div class="images-carousel__wrap">
          <div ref="carousel" class="images-carousel__container">
            <div class="images-carousel__list">
              <div v-for="(item, index) in carousel.images"
                   :key="item.id"
                   class="images-carousel__slide">
                <a
                  :href="item.image"
                  @click.prevent="onSlideClick(index)"
                  class="images-carousel__slide-inner swiper-lazy">
                  <img :data-src="item.image"
                       :alt="item.id"
                       class="swiper-lazy"
                  >
                  <div class="swiper-lazy-preloader image-preloader"></div>

                  <div class="images-carousel__slide-overlay">
                    <i class="eti eti_plus"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <button ref="slide-prev" type="button" class="images-carousel__nav _prev">
          <i class="fa fa-angle-left"></i>
        </button>
        <button ref="slide-next" type="button" class="images-carousel__nav _next">
          <i class="fa fa-angle-right"></i>
        </button>
      </div>
      <div v-if="caption"
           class="images-carousel__caption"
      >{{caption}}
      </div>
    </div>

    <LightBox :items="clearPhotosArray"
              :index="index"
              @close="onSlideClick(null)"/>
  </section>
</template>

<script>
  import Swiper from 'swiper'
  import LightBox from '../components/LightBox'

  export default {
    name: 'ImagesCarousel',
    components: {
      LightBox
    },
    props: {
      carousel: {
        type: Object,
        required: true
      },
      caption: {
        type: String,
        default: null
      },
      isGallery: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        swiper: null,
        index: null,
      }
    },
    computed: {
      selector() {
        return {
          '_gallery': this.isGallery
        }
      },
      clearPhotosArray() {
        if(!Array.isArray(this.carousel.images)) return []
        return this.carousel.images.map(item => item.image)
      }
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['carousel'], {
          wrapperClass: 'images-carousel__list',
          slideClass: 'images-carousel__slide',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          watchSlidesVisibility: true,
          speed: 600,
          navigation: {
            prevEl: this.$refs['slide-prev'],
            nextEl: this.$refs['slide-next'],
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          },
          preloadImages: false,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: this.isGallery ? 1 : 4
          }
        })
      },
      onSlideClick(index) {
        this.index = index
      },
      update() {
        this.swiper.destroy()
        setTimeout(() => {
          this.createSwiper()
        })
      }
    },
    mounted() {
      this.createSwiper()
    },
    // updated() {
    //   this.swiper.destroy()
    //   this.createSwiper()
    // },
    beforeDestroy() {
      this.swiper.destroy()
    },
    watch: {
      carousel() {
        this.update()
      }
    }
  }
</script>

<style>

</style>
